export default {
  GET_STAGES(state) {
    return state.stages
  },
  GET_STAGE_PLANNINGS(state) {
    return state.stage_plannings
  },
}
